// extracted by mini-css-extract-plugin
module.exports = {"table":"_3HK1N"};